import {
  CellTemplate,
  Compatible,
  isAlphaNumericKey,
  keyCodes,
  Uncertain,
  UncertainCompatible,
} from "@silevis/reactgrid";
import { ReactNode } from "react";
import { Radio } from "antd";
import { Styles } from "./Style";
import { getOptionsFormAppPart } from "@lhd/components/CloneApp/fieldUtils";
import { CellCustomType } from "../../type";

export class RadioCellTemplate implements CellTemplate<CellCustomType> {
  getCompatibleCell(
    uncertainCell: Uncertain<CellCustomType>,
  ): Compatible<CellCustomType> {
    const uncertainCellAs = uncertainCell as CellCustomType;
    return {
      value: NaN,
      ...uncertainCellAs,
    };
  }

  getClassName(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
  ): string {
    return cell.className || "";
  }

  update(
    cell: Compatible<CellCustomType>,
    cellToMerge: UncertainCompatible<CellCustomType>,
  ): Compatible<CellCustomType> {
    return this.getCompatibleCell({
      ...cell,
      text: cellToMerge.text,
      valueSubmit: cellToMerge.valueSubmit,
    });
  }

  handleKeyDown(
    cell: Compatible<CellCustomType>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<CellCustomType>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode))
      return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode:
        keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }

  render(
    cell: Compatible<CellCustomType>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<CellCustomType>, commit: boolean) => void,
  ): ReactNode {
    if (!isInEditMode) {
      return cell.text;
    }
    const options = getOptionsFormAppPart(cell.appPart);

    return (
      <Styles onPointerDown={(e) => e.stopPropagation()}>
        <Radio.Group
          style={{ flexDirection: "column" }}
          defaultValue={cell.valueSubmit}
          options={options}
          onChange={(e) => {
            const value = e.target.value as string;
            const updatedCell = this.getCompatibleCell({
              ...cell,
              text: value,
              valueSubmit: value,
            });

            onCellChanged(updatedCell, false);
          }}
        />
      </Styles>
    );
  }
}
